import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Shows from "@/views/Shows.vue";
import Classes from "../views/Classes.vue";
import Visit from "../views/Visit.vue";
import Company from "../views/Company.vue";
import HireUs from "../views/HireUs.vue";
import NotFound from "@/views/NotFound.vue";
import Contact from "@/views/Contact.vue";
import Subscribe from "@/views/Subscribe.vue";

const routes = [
  // Redirect /shows.php to /shows
  {
    path: "/shows.php",
    redirect: "/shows"
  },
  // Redirect /press to /contact
  {
    path: "/press",
    redirect: "/contact"
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Atlas Improv – Home",
      description: "Learn improv in Madison at Atlas Improv"
    }
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      title: "Atlas Improv – About Us",
      description: "Our mission, our team, our space."
    }
  },
  {
    path: "/shows",
    name: "shows",
    component: Shows,
    meta: {
      title: "Atlas Improv – Shows",
      description: "Explore upcoming shows at Atlas Improv"
    }
  },
  {
    path: "/classes",
    name: "classes",
    component: Classes,
    meta: {
      title: "Atlas Improv – Classes",
      description: "Sign up for improv classes at Atlas Improv"
    }
  },

  {
    path: "/Subscribe",
    name: "subscribe",
    component: Subscribe,
    meta: {
      title: "Atlas Improv – Subscribe",
      description: "Subscribe to Atlas Improv updates and news"
    }
  },
  {
    path: "/visit",
    name: "visit",
    component: Visit,
    meta: {
      title: "Atlas Improv – Visit",
      description: "Plan your visit to Atlas Improv in Madison"
    }
  },
  {
    path: "/company",
    name: "company",
    component: Company,
    meta: {
      title: "Atlas Improv – Company",
      description: "Meet the Atlas Improv company members"
    }
  },
  {
    path: "/hireus",
    name: "hireus",
    component: HireUs,
    meta: {
      title: "Atlas Improv – Hire Us",
      description: "Book Atlas Improv for your next event"
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      title: "Atlas Improv – Contact",
      description: "Get in touch with Atlas Improv in Madison."
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "Atlas Improv – Not Found",
      description: "The page you are looking for was not found at Atlas Improv."
    }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(to,from)
    if (savedPosition) {
      return 0;
    } else {
      return { top: 0 };
    }
  }
});

export default router;
